import { router } from '@lifedot/router'
import { css } from '@emotion/react'
import { Label } from '@lifedot/atoms/Label'
import { Rating } from '@lifedot/atoms/Rating'
import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'

const styles = {
  name: css({
    display: 'block',
    fontWeight: 'bold',
    fontSize: 16,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }),
  labels: css({
    marginBottom: -4,
    '> *': {
      marginRight: 4,
      marginBottom: 4
    }
  })
}

interface OverviewProps {
  cemeteryId: number
  name: string
  labels: { code: string; name: string }[]
  img: { path: string; alt: string }
  review?: { score: number; count: number }
}

export const Overview: FC<OverviewProps> = ({
  cemeteryId,
  name,
  labels,
  img,
  review
}) => {
  return (
    <>
      <Image src={img.path} alt={img.alt} width={800} height={600} priority />
      <Link href={router.cemetery(cemeteryId)} passHref prefetch={false}>
        <a css={styles.name}>{name}</a>
      </Link>
      {review && <Rating point={review.score} />}
      <div css={styles.labels}>
        {labels.map((label) => (
          <Label key={label.code} color="gray6">
            {label.name}
          </Label>
        ))}
      </div>
    </>
  )
}
